const SaawisLogo = () => {
  return (
    <svg viewBox="0 0 50 50">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_2134"
            data-name="Rectangle 2134"
            width="50"
            height="50"
            transform="translate(1230 942)"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
        <filter
          id="Ellipse_17"
          x="-61"
          y="-10"
          width="172"
          height="135"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="20" result="blur" />
          <feFlood floodColor="#075da9" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Mask_Group_2"
        data-name="Mask Group 2"
        transform="translate(-1230 -942)"
        clipPath="url(#clip-path)"
      >
        <g id="Group_139" data-name="Group 139" opacity="0">
          <g
            transform="matrix(1, 0, 0, 1, 1230, 942)"
            filter="url(#Ellipse_17)"
          >
            <ellipse
              id="Ellipse_17-2"
              data-name="Ellipse 17"
              cx="26"
              cy="7.5"
              rx="26"
              ry="7.5"
              transform="translate(-1 50)"
            />
          </g>
        </g>
        <g id="Group_142" data-name="Group 142">
          <g
            id="Group_140"
            data-name="Group 140"
            transform="translate(605 640)"
          >
            <path
              id="Path_15"
              data-name="Path 15"
              d="M140,109.98h7v.706h-7Z"
              transform="translate(503 209.55)"
              opacity="0.8"
            />
            <path
              id="Path_16"
              data-name="Path 16"
              d="M140,109.98h14.059v.706H140Z"
              transform="translate(503 216.609)"
              opacity="0.8"
            />
            <path
              id="Path_17"
              data-name="Path 17"
              d="M140,109.98h7.059v.706H140Z"
              transform="translate(510 223.668)"
              opacity="0.8"
            />
            <path
              id="Path_1"
              data-name="Path 1"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(593.633 270.633)"
            />
            <path
              id="Path_6"
              data-name="Path 6"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(593.633 277.692)"
            />
            <path
              id="Path_9"
              data-name="Path 9"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(593.633 284.75)"
            />
            <path
              id="Path_2"
              data-name="Path 2"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(600.692 270.633)"
            />
            <path
              id="Path_4"
              data-name="Path 4"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(600.692 277.692)"
            />
            <path
              id="Path_7"
              data-name="Path 7"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(600.692 284.75)"
            />
            <path
              id="Path_3"
              data-name="Path 3"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(607.75 270.633)"
            />
            <path
              id="Path_5"
              data-name="Path 5"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(607.75 277.692)"
            />
            <path
              id="Path_8"
              data-name="Path 8"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(607.75 284.75)"
            />
          </g>
          <g
            id="Group_141"
            data-name="Group 141"
            transform="translate(605 640)"
            opacity="0"
          >
            <path
              id="Path_15-2"
              data-name="Path 15"
              d="M140,109.98h7v.706h-7Z"
              transform="translate(503 209.55)"
              fill="#075da9"
              opacity="0.8"
            />
            <path
              id="Path_16-2"
              data-name="Path 16"
              d="M140,109.98h14.059v.706H140Z"
              transform="translate(503 216.609)"
              fill="#075da9"
              opacity="0.8"
            />
            <path
              id="Path_17-2"
              data-name="Path 17"
              d="M140,109.98h7.059v.706H140Z"
              transform="translate(510 223.668)"
              fill="#075da9"
              opacity="0.8"
            />
            <path
              id="Path_1-2"
              data-name="Path 1"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(593.633 270.633)"
              fill="#075da9"
            />
            <path
              id="Path_6-2"
              data-name="Path 6"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(593.633 277.692)"
              fill="#075da9"
            />
            <path
              id="Path_9-2"
              data-name="Path 9"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(593.633 284.75)"
              fill="#075da9"
            />
            <path
              id="Path_2-2"
              data-name="Path 2"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(600.692 270.633)"
              fill="#075da9"
            />
            <path
              id="Path_4-2"
              data-name="Path 4"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(600.692 277.692)"
              fill="#075da9"
            />
            <path
              id="Path_7-2"
              data-name="Path 7"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(600.692 284.75)"
              fill="#075da9"
            />
            <path
              id="Path_3-2"
              data-name="Path 3"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(607.75 270.633)"
              fill="#075da9"
            />
            <path
              id="Path_5-2"
              data-name="Path 5"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(607.75 277.692)"
              fill="#075da9"
            />
            <path
              id="Path_8-2"
              data-name="Path 8"
              d="M49.308,47.367a1.941,1.941,0,1,0,1.941,1.941A1.941,1.941,0,0,0,49.308,47.367Z"
              transform="translate(607.75 284.75)"
              fill="#075da9"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SaawisLogo;
